import { render, staticRenderFns } from "./ContainerFAQDetail.vue?vue&type=template&id=526fdc75"
import script from "./ContainerFAQDetail.vue?vue&type=script&lang=js"
export * from "./ContainerFAQDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports